module.exports = __webpack_public_path__ + "img/grouppic.fc2a81c7.png";